// @ts-expect-error module not typed
import PrimaryMessageFooter from '../primary-message/components/PrimaryMessageFooter';
import DeliveryStatusTag from './DeliveryStatusTag';
// @ts-expect-error module not typed
import { getDeliveryStatus } from 'conversations-message-history/util/getDeliveryStatus';
import { getStatusTimestamp, getStatus
// @ts-expect-error module not typed
} from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { LAST_READ_RECEIPT_MESSAGE } from 'conversations-message-history/constants/messagePositionDescriptors';
import { READ as STATUS_READ } from 'conversations-message-history/common-message-format/constants/statusTypes';
import { READ as MESSAGE_DELIVERY_READ } from 'conversations-message-history/constants/messageDeliveryStatuses';
import { jsx as _jsx } from "react/jsx-runtime";
const DeliveryStatusFooter = ({
  timestamp,
  status,
  positionDescriptors,
  visitorLastReadTimestamp
}) => {
  const readTimestamp = getStatus({
    status
  }) === STATUS_READ ? getStatusTimestamp({
    status
  }) : visitorLastReadTimestamp;
  const deliveryStatus = getDeliveryStatus(timestamp, readTimestamp);
  const isLastReadReceiptMessage = positionDescriptors.includes(LAST_READ_RECEIPT_MESSAGE);
  if (!isLastReadReceiptMessage || !deliveryStatus) {
    return null;
  }
  return /*#__PURE__*/_jsx(PrimaryMessageFooter, {
    children: /*#__PURE__*/_jsx(DeliveryStatusTag, {
      deliveryStatus: deliveryStatus,
      timestamp: deliveryStatus === MESSAGE_DELIVERY_READ ? readTimestamp : timestamp
    })
  });
};
DeliveryStatusFooter.displayName = 'DeliveryStatusFooter';
export default DeliveryStatusFooter;